import "core-js/modules/es.array.push.js";
import colorModel from './colorModel.vue';
import { recursionCopy } from '@/views/customer/roleManage/utils';
export default {
  components: {
    colorModel
  },
  props: {
    configureList: {
      type: Array,
      default() {
        return [];
      }
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {},
      colorShow: false,
      btnIndex: -1,
      btnIndex1: -1
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.form = recursionCopy(this.styleObj);
      console.log(this.form, '--------保单详情页--------');
    });
  },
  methods: {
    // 按钮文案去除前后空格
    handleBlurTrim(val, index) {
      this.form.buttonInfo[index].buttonName = val.trim();
      this.changeFun();
    },
    disabledEvent(val, key) {
      let res = val.findIndex(i => i.buttonEvent == key);
      return res > -1 ? true : false;
    },
    onChangePopup(e, index) {
      this.form.buttonInfo[index].buttonPopUp = e.target.checked;
      this.form.buttonInfo[index].buttonPopUpConfig = {
        popUpPosition: 'central',
        //弹窗位置:中部central、底部bottom
        popUpTitle: '',
        //弹窗标题
        popUpContent: '',
        //弹窗内容
        buttonInfo: [
        //按钮配置
        {
          buttonName: '',
          //按钮文案
          buttonFontColor: '#fff',
          //按钮文字颜色
          buttonBgColor: '#FF6B00',
          //按钮颜色
          buttonEvent: '',
          //按钮事件:关闭弹窗close、跳转页面jump
          controlsJump: undefined
        }]
      };
      this.changeFun();
    },
    changeFun() {
      console.log(this.form);
      this.$emit('itemChange', this.form);
    },
    imgClick(val, id) {
      this.form.controlsComponentsMark = val;
      this.form.controlsComponentsId = id;
      if (this.form.isPremium && (this.form.controlsComponentsMark == 'bottomButton1' || this.form.controlsComponentsMark == 'bottomButton2')) {
        this.form.buttonColor = this.themeColor;
      } else {
        this.form.buttonColor = '#fff';
      }
      this.changeFun();
    },
    changeremiumFun() {
      this.form.isPremium = !this.form.isPremium;
      if (this.form.isPremium && (this.form.controlsComponentsMark == 'bottomButton1' || this.form.controlsComponentsMark == 'bottomButton2')) {
        this.form.buttonColor = this.themeColor;
      } else {
        this.form.buttonColor = '#fff';
      }
      this.changeFun();
    },
    addPopupBtnFun(index) {
      this.form.buttonInfo[index].buttonPopUpConfig.buttonInfo.push({
        buttonName: '',
        //按钮文案
        buttonFontColor: this.form.buttonInfo[index].buttonPopUpConfig.buttonInfo[0].buttonBgColor,
        //按钮文字颜色
        buttonBgColor: this.form.buttonInfo[index].buttonPopUpConfig.buttonInfo[0].buttonFontColor,
        //按钮颜色
        buttonEvent: '',
        //按钮事件:关闭弹窗close、跳转页面jump
        controlsJump: undefined
      });
      this.changeFun();
    },
    delPopupBtnFun(index, index1) {
      this.form.buttonInfo[index].buttonPopUpConfig.buttonInfo.splice(index1, 1);
      this.changeFun();
    },
    addBtnFun() {
      this.form.buttonInfo.push({
        buttonName: '',
        buttonFontColor: this.themeColor,
        buttonBgColor: '#fff',
        mark: 1,
        buttonPopUp: false,
        buttonPopUpConfig: {
          popUpPosition: 'central',
          //弹窗位置:中部central、底部bottom
          popUpTitle: '',
          //弹窗标题
          popUpContent: '',
          //弹窗内容
          buttonInfo: [
          //按钮配置
          {
            buttonName: '',
            //按钮文案
            buttonFontColor: '#fff',
            //按钮文字颜色
            buttonBgColor: '#FF6B00',
            //按钮颜色
            buttonEvent: '',
            //按钮事件:关闭弹窗close、跳转页面jump
            controlsJump: undefined // 模板组绑定值
          }]
        }
      });
      this.changeFun();
    },
    delBtnFun(index) {
      this.form.buttonInfo.splice(index, 1);
      this.changeFun();
    },
    colorClickFun(val, key, index, index1 = -1) {
      this.btnIndex = index;
      this.btnIndex1 = index1;
      this.colorShow = true;
      this.$nextTick(() => {
        this.$refs.colorRef.init(val, key);
      });
    },
    colorFun(val, key) {
      if (this.btnIndex != -1) {
        if (this.btnIndex1 > -1) {
          this.form.buttonInfo[this.btnIndex].buttonPopUpConfig.buttonInfo[this.btnIndex1][key] = val;
        } else {
          this.form.buttonInfo[this.btnIndex][key] = val;
        }
      } else {
        this.form.buttonColor = val;
      }
      this.changeFun();
      this.colorShow = false;
    }
  }
};